const VideoPlayIcon = ({ viewBox = "0 0 32 32", className = "hayley-h-8 hayley-w-8 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M13.6 23.8C12.9408 24.2944 12 23.824 12 23V9C12 8.17595 12.9408 7.70557 13.6 8.2L22.9333 15.2C23.4667 15.6 23.4667 16.4 22.9333 16.8L13.6 23.8Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default VideoPlayIcon;
